import { Box, Typography } from '@mui/material';
import GeneralStep1 from 'assets/GeneralStep1.webp';
import GeneralStep2 from 'assets/GeneralStep2.webp';
import { allowedFilesMap } from './DataSetForm';

export default function NaiveDescription() {
  return (
    <Box>
      <Typography variant='h6'>"General" Chunking Method Description</Typography>
      <Typography marginTop={2}>Supported file formats are {allowedFilesMap.naive.join(', ')}.</Typography>
      <Typography marginTop={3}>This method apply the naive ways to chunk files:</Typography>
      <ul>
        <li>Successive text will be sliced into pieces using vision detection model.</li>
        <li>Next, these successive pieces are merge into chunks whose token number is no more than 'Token number'.</li>
      </ul>
      <Typography fontWeight='500'>"General" Examples</Typography>
      <Typography marginBottom={3}>The following screenshots are presented to facilitate understanding.</Typography>
      <Box display='flex' overflow='auto' justifyContent='center' gap={1}>
        <img src={GeneralStep1} alt='GeneralStep1' width={320} />
        <img src={GeneralStep2} alt='GeneralStep2' width={320} />
      </Box>
    </Box>
  );
}
